import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SiteActions, SnackbarActions } from 'actionsets'
import { Pagination, ErrorBanner, TaggedSearchField, LabeledSwitch } from 'components'
import AddIcon from '@material-ui/icons/Add'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MuiList from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SiteIcon from '@material-ui/icons/LocationOn'
import { compose, errorStringsFromError, throttle } from 'utils'
import { withRouter } from 'react-router-dom'
import { connectQueryString } from 'containers/shared'
import { withPermissions } from 'containers/shared'
import { FABAbsolute } from 'components'

export class List extends Component{

  static requiredPermissions = props => {
    const organisationId = props.organisationId || props.match.params.id
    return {
      organisation: {
        ...organisationId && { [organisationId]: ['writeSites'] }
      }
    }
  }

  constructor(props){
    super(props)
    SiteActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
    this.loadSites()
  }

  componentDidMount(){
    return this.loadSites()
  }

  loadSites = throttle(() => {
    return this.actions.index({
      params: { organisationId: this.organisationId },
      clearExisting: true,
      pageSize: 10,
      page: this.props.page,
      filter: this.props.filter,
      fields: {sites: 'name,kwAmount'}
    })
  })

  componentDidUpdate = prevProps => {
    if (this.props.organisationId !== prevProps.organisationId) {
      this.loadSites()
    }
  }

  dependenciesMet(){
    return this.props.requests.length === 0
  }

  handleShowSite = id => () => {
    this.props.history.push(`/sites/${id}`)
  }

  handleEditSite = id => event => {
    this.props.history.push(`/sites/${id}/edit`)
    event.stopPropagation()
  }

  handleDeleteSite = id => event => {
    this.actions.destroy({id})
                .then(this.loadSites)
                .catch(error => this.actions.snackbar.show(errorStringsFromError(error).join(', ')))
    event.stopPropagation()
  }

  handleFilterChanged = async rawFilter => {
    const filter = {...rawFilter, tags: {}};
    (rawFilter.tags || []).forEach(({value, tagType: { name }}) => {
      if(!filter.tags[name]) filter.tags[name] = []
      filter.tags[name].push(value)
    })
    await this.props.onFilterChange(filter)
    this.loadSites()
  }

  handlePageSelected = async page =>{
    await this.props.onPageChange(page)
    this.loadSites()
  }

  get permissions(){
    return (((this.props.permissions || {}).organisation || {})[this.organisationId] || {})
  }

  get organisationId(){
    return this.props.organisationId || this.props.match.params.id
  }

  get sites(){
    return this.props.sites
  }

  get errors(){
    let errors = []
    if(this.props.errors.index){
      errors = errors.concat(this.props.errors.index)
    }
    if(this.props.errors.destroy){
      errors = errors.concat(this.props.errors.destroy)
    }
    return errors
  }

  renderSiteListItem = ({id, name, kwAmount}) =>
    <ListItem button onClick={this.handleShowSite(id)} key={id}>
      <ListItemIcon>
        <SiteIcon />
      </ListItemIcon>
      <ListItemText primary={name} secondary={`${kwAmount}kW`}/>
    </ListItem>

  renderErrorMessages = () =>
    <ErrorBanner>
      {errorStringsFromError(this.errors)}
    </ErrorBanner>

  render = () =>
    <Card>
      <CardContent>
        {this.renderErrorMessages()}
        <TaggedSearchField onChange={this.handleFilterChanged} context={this.props.filter}>
          {this.organisationId &&
            <LabeledSwitch checked={!('includeDescendantOrganisations' in this.props.filter) || this.props.filter.includeDescendantOrganisations === 'true'} label="Include nested organisations" member="includeDescendantOrganisations" />
          }
        </TaggedSearchField>
        <MuiList dense>
          {this.sites.map(this.renderSiteListItem)}
        </MuiList>
        <Pagination totalPages={this.props.totalPages} page={this.props.page} onPageSelected={this.handlePageSelected} style={{}} linkStyle={{}}/>
        {
          this.permissions.writeSites &&
          <FABAbsolute color='primary' onClick={() => this.props.history.push(`/organisations/${this.organisationId}/sites/new`)}>
            <AddIcon/>
          </FABAbsolute>
        }
      </CardContent>
    </Card>
}

export default compose(
  withPermissions(List.requiredPermissions),
  connectQueryString('sites'),
  withRouter,
  connect(({sites}) => sites)
)(List)